import React from 'react';
import { connect } from 'react-redux';
import { number, object, string, arrayOf } from 'prop-types';

import {
  ItemInformationContainer,
  ItemName,
  ItemProperty,
  ItemPropertyContainer,
  ItemPropertyList,
  ItemStatus,
} from './styles';

import { formatCurrencyValue } from '../../../lib/currencyFormatters';
import { Language } from '../../Language';
import { ItemSubtotal } from './itemSubtotal';

const mapStateToProps = ({ language: lang, page: { locale } }) => ({
  lang,
  locale,
});

export const formatValue = ({ key, value, locale }) => {
  if (key === 'Price') {
    return formatCurrencyValue({ value, locale });
  }
  return value;
};

const generateItemList = ({ itemProperties, locale, itemIndex }) => {
  const displayableItems = itemProperties
    .filter(({ displayable }) => displayable)
    .sort(({ displayOrder: a }, { displayOrder: b }) => a - b);

  return (
    <React.Fragment>
      {displayableItems.map(({ key, value }, propIndex) => (
        <ItemProperty className={key} key={key}>
          <Language
            content={`${key}: `}
            className={`return-item-${itemIndex}-property-${propIndex}-key`}
          />
          <Language
            content={formatValue({ key, value, locale })}
            className={`return-item-${itemIndex}-property-${propIndex}-value`}
          />
        </ItemProperty>
      ))}
    </React.Fragment>
  );
};

const ItemPropertiesComponent = ({
  itemIndex,
  itemName,
  item,
  lang,
  locale,
  eligibleStatus,
  itemQtyKey = 'remaining_qty',
}) => (
  <ItemInformationContainer className="returnItem-module_item_information_container_">
    <ItemName
      className={`returnItem-module_item_name_ return-summary-item return-item-${itemIndex}-name`}
      role="heading"
      aria-level="3"
    >
      <Language content={itemName} />
    </ItemName>
    <ItemPropertyContainer className="returnItem-module_item_property_container_">
      <ItemPropertyList className="returnItem-module_item_property_list_">
        {item.item_properties &&
          generateItemList({
            itemProperties: item.item_properties,
            locale,
            itemIndex,
          })}
        {item.item_price !== undefined && !item.display_default_properties && (
          <ItemProperty className="item-price-display">
            <span className={`return-item-${itemIndex}-price-key`}>
              {lang['returns.item.price_label']}
            </span>
            <span className={`return-item-${itemIndex}-price-value`}>
              {formatValue({ key: 'Price', value: item.item_price, locale })}
            </span>
          </ItemProperty>
        )}
        {item[itemQtyKey] && !item.display_default_properties && (
          <ItemProperty className="return-item-qty">
            <Language
              className={`return-item-${itemIndex}-qty-key`}
              langKey="returns.item.qty_label"
            />
            <Language className={`return-item-${itemIndex}-qty-value`} content={item[itemQtyKey]} />
          </ItemProperty>
        )}

        {item.item_category && !item.display_default_properties && (
          <ItemProperty className="return-item-category">
            <Language
              className={`return-item-${itemIndex}-category-key`}
              key="returns.item.category_label"
            />
            <span className={`return-item-${itemIndex}-category-value`}>{item.item_category}</span>
          </ItemProperty>
        )}
      </ItemPropertyList>
    </ItemPropertyContainer>
    <div>
      {item.clearance_sale && <ItemStatus>{lang['returns.item.clearance_sale']}</ItemStatus>}
      {item.return_desc && (
        <ItemStatus className="return-item-status-text">
          {[lang['returns.item.reason_label'] || '', item.return_desc].join(' ')}
        </ItemStatus>
      )}
      {eligibleStatus && (
        <ItemStatus className="return-item-eligible-text returnItem-module_item_status_">
          {eligibleStatus}
        </ItemStatus>
      )}
    </div>
    <ItemSubtotal itemSubtotal={item.total_price} />
  </ItemInformationContainer>
);

export const ItemProperties = connect(mapStateToProps)(ItemPropertiesComponent);

ItemPropertiesComponent.defaultProps = {
  eligibleStatus: '',
  itemQtyKey: 'remaining_qty',
};

ItemPropertiesComponent.propTypes = {
  itemIndex: number.isRequired,
  itemName: string.isRequired,
  item: object.isRequired,
  lang: object.isRequired,
  locale: string.isRequired,
  eligibleStatus: string,
  itemQtyKey: string,
};

generateItemList.propTypes = {
  itemProperties: arrayOf(object).isRequired,
  locale: string.isRequired,
  itemIndex: number.isRequired,
};
